import React from 'react';
import { Row } from 'reactstrap';
import 'react-toggle/style.css';
import { ChevronDown, ChevronUp } from 'react-feather';
import ViewsTable from '../../../components/tables/ViewsTable';

class ViewableSchedule extends React.Component {
	constructor(props) {
		super(props);
		const columns = {
			name: 'Session Name',
			startTime: 'Start Time',
			endTime: 'End Time',
			location: 'Location',
			attendees: 'Attended',
			checkedIn: 'Checked In',
			allDay: 'All Day',


		};
		const columnTypes = {
			name: 'text',
			location: 'text',
			attendees: 'text',
			checkedIn: 'text',
			endTime: 'text',
			startTime: 'text',
			allDay: 'boolean'


		};
		const columnWidths = {
			name: 150,
			location: 150,
			attendees: 150,
			checkedIn: 150,
			endTime: 150,
			startTime: 150,
			allDay: 100
		};
		const toggledColumns = {};
		const normalizedColumns = Object.keys(columns).map((cfc) => {
			toggledColumns[cfc] = true;
			return {
				label: columns[cfc],
				key: cfc,
				value: cfc,
				type: columnTypes[cfc],
				sortAsc: false,
				sortDesc: false
			};
		});

		this.state = {
			expanded: true,
			normalizedColumns: normalizedColumns,
			columnWidths: columnWidths,
			sessions: this.props.sessions,
			toggledColumns: toggledColumns
		};
	}


	toggleExpand = () => {
		this.setState({ expanded: !this.state.expanded });
	};

	render() {
		const { expanded, normalizedColumns, columnWidths, toggledColumns } = this.state;
		const { date, index, isEmpty, sessions, attendedSessions, attendee } = this.props;
		let sessionData = sessions.map((session) => {
			const checkedIn = session.checkins?.find(ch => ch.attendeeId == attendee._id);
			return {
				_id: session._id,
				name: session.name,
				location: this.props.locations[session.location],
				attendees: attendedSessions.includes(session._id) || checkedIn ? 'Yes' : 'No',
				checkedIn: checkedIn ? 'Yes' : 'No',
				startTime: !session.isAllDay ? session.startTime : '-',
				endTime: !session.isAllDay ? session.endTime : '-',
				allDay: session.isAllDay ? 'Yes' : 'No',
				excluded: session.excluded,
				inGroup: session.inGroup,
				isGeneral: session.isGeneral,
				isStrikeThrough: session.excluded
			}
		})
		let rowSettings = [
			{
				label: 'Remove',
				onClick: (sessionId) => {
					this.props.toggleRemove(sessionId, false);
				},
				displayCondition: (session) => !session.inGroup && !session.isGeneral && !session.excluded
			},
			{
				label: 'Exclude',
				onClick: (sessionId) => {
					console.log('exclude', sessionId);
					this.props.toggleRemove(sessionId, true);
				},
				displayCondition: (session) => !session.excluded && (session.inGroup || session.isGeneral)
			},
			{
				label: 'Include',
				onClick: (sessionId) => {
					this.props.toggleInclude(sessionId);
				},
				displayCondition: (session) => session.excluded
			}
		];

		return (
			<div index={index} className="rowSchedule horizontal" style={{ borderBottom: !isEmpty && '1px solid grey', padding: 0, overflowX: 'hidden' }}>
				<Row style={{ padding: '15px 10px' }}>
					<div className="col-9" style={{ fontWeight: 'bold' }}>
						{'    '}
						{isEmpty ? 'Date' : date} <span style={{ fontWeight: '200' }} />
					</div>
					<div className="col-3" style={{ textAlign: 'right' }}>
						{!isEmpty && expanded ? (
							<ChevronUp
								onClick={this.toggleExpand}
								style={{ margin: 'auto', marginLeft: '5px', marginTop: '-10px' }}
							/>
						) : (
							<ChevronDown
								onClick={this.toggleExpand}
								style={{ margin: 'auto', marginLeft: '5px', marginTop: '-10px' }}
							/>
						)}
					</div>
				</Row>
				{expanded && (
					<ViewsTable
						classes={'noBorder attendeeScheduleTable'}
						style={{ height: (40 * sessionData.length) + 60 }}
						title={"Sessions"}
						columns={normalizedColumns}
						columnWidths={{ ...columnWidths }}
						toggledColumns={toggledColumns}
						data={sessionData}
						mainColumnActive={false}
						columnWidth={columnWidths}
						checked={{}}
						disableCheck={true}
						activeRow={null}
						rowSettings={rowSettings}
					/>
				)}
			</div>
		);
	}
}

export default ViewableSchedule;
